<template>
	<div>
		<StepOne @nextStep="nextStep()" v-if="step === 1" />
		<StepTwo @nextStep="nextStep()" v-if="step === 2" />
		<StepThree @nextStep="nextStep()" @alvaraAnexo="alvaraAnexo" v-if="step === 3" />
		<StepFour :alvara="alvara" :extensao="extensao" @submitProcess="submitProcess" v-if="step === 4" />
		<StepFive :result="result" v-if="step === 5" />
	</div>
</template>
<script>
import StepOne from './steps/StepOne.vue'
import StepTwo from './steps/StepTwo.vue'
import StepThree from './steps/StepThree.vue'
import StepFour from './steps/StepFour.vue'
import StepFive from './steps/StepFive.vue'
export default {
	name: 'SolicitacaoDemarcacaoLote',
	components: {
		StepOne,
		StepTwo,
		StepThree,
		StepFour,
		StepFive,
	},

	data() {
		return {
			step: 1,
			lastStep: 5,
			result: null,
			alvara: null,
			extensao: null,
		}
	},

	methods: {
		nextStep() {
			if (this.step < this.lastStep) {
				this.step++
			}
		},

		alvaraAnexo(dados) { 
			this.alvara = dados.alvara
			this.extensao = dados.extensao
		},

		submitProcess(value) {
			this.result = value
			this.nextStep()
		},
	},
}
</script>
